var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"cta-link",attrs:{"href":_vm.url,"target":"_blank"}},[_c('div',{staticClass:"cta-flex"},[_c('span',[_vm._v(_vm._s(_vm.text))]),_vm._v(" "),_c('img',{staticClass:"cta-icon",attrs:{"src":require("../assets/cta-arrow.svg"),"alt":"Click arrow","aria-hidden":"true"}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-35c3dcbe","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Cta.vue
// module id = null
// module chunks = 